import type { GHABlockedIdentityEvidence, GHAEmailClassification } from '~/services/ConnectionGoogleService';

export const GHA_EMAIL_CLASSIFICATION_OPTIONS: Array<{ value: GHAEmailClassification; label: string }> = [
  { value: 'hotel', label: 'Hotel' },
  { value: 'uncertain', label: 'Uncertain' },
  { value: 'consumer', label: 'Consumer' },
];

export const GHA_EMAIL_CLASSIFICATION_LABELS: Record<string, string> = Object.fromEntries(
  GHA_EMAIL_CLASSIFICATION_OPTIONS.map((option) => [option.value, option.label]),
);

export const GHA_EMAIL_CLASSIFICATION_CHIP_COLORS: Record<GHAEmailClassification, 'error' | 'warning' | 'default'> = {
  hotel: 'error',
  uncertain: 'warning',
  consumer: 'default',
};

// The API caps `limit` at 100.
export const GHA_EMAIL_DOMAIN_RULES_PAGE_SIZE_OPTIONS = [10, 50, 100];
export const GHA_EMAIL_DOMAIN_RULES_DEFAULT_PAGE_SIZE = 50;

// The page's sub-tabs, kept in `?section=` like GHA Discounting.
export const GHA_EMAIL_RULES_SECTIONS = ['domain-rules', 'blocked-identities'] as const;
export type GHAEmailRulesSection = (typeof GHA_EMAIL_RULES_SECTIONS)[number];

// Evidence fields in display order, with the bulk CSV column for each.
export const GHA_BLOCKED_IDENTITY_EVIDENCE_FIELDS: Array<{
  key: keyof GHABlockedIdentityEvidence;
  label: string;
  column: string;
}> = [
  { key: 'name', label: 'Name', column: 'name' },
  { key: 'phone', label: 'Phone', column: 'phone' },
  { key: 'ip', label: 'IP', column: 'ip' },
  { key: 'bookingId', label: 'Booking ID', column: 'booking_id' },
  { key: 'propertyId', label: 'Property ID', column: 'property_id' },
  { key: 'hotel', label: 'Hotel', column: 'hotel' },
  { key: 'currency', label: 'Currency', column: 'currency' },
  { key: 'region', label: 'Region', column: 'region' },
  { key: 'caseRef', label: 'Case ref', column: 'case_ref' },
  { key: 'raisedBy', label: 'Raised by', column: 'raised_by' },
];
